exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-padding-top{\n    padding-top: 0px\n}\n\n.custom-padding-bottom{\n    padding-bottom: 0px\n}\n\n.custom-margin-left{\n    margin-left: 15px\n}\n\n.custom-remove{\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n    border-left: #8080803d;\n    border-style: solid;\n    border-width: 1px;\n}\n\n.custom-btn {\n    margin-bottom: 5px;\n    margin-right: 5px;\n    padding: 0px 0px 0px 3px;\n\n}\n.custom-radius {\n    border-radius: 0px;\n    border-right: none;\n    border-top: none;\n    border-bottom: none;\n}\n.custom-icon{\n    cursor: pointer;\n}\n.btn-circle {\n    width: 30px;\n    height: 30px;\n    padding: 6px 0px;\n    border-radius: 15px;\n    text-align: center;\n    font-size: 12px;\n    line-height: 1.42857;\n}\n.custom-glyph{\n    padding-right: 0px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/projects/show/show-project.component.css
// module id = ../../../../../src/app/projects/show/show-project.component.css
// module chunks = main